import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import useProductValidationSchema from './ProductFormFields/useValidationSchema';

export default function useValidationSchema() {
  const { t } = useTranslation('CreateCropOrder');

  return yup.object().shape({
    products: yup
      .array()
      .label(t('labels.products'))
      .of(useProductValidationSchema())
      .ensure()
      .min(1)
      .default([]),
  });
}
